module.exports = __webpack_public_path__ + "img/jaune-7.da3afc53.png";